import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MUITable from "Components/UI/Tables/MUITable";
import cutStrAtAndAddDots from "utils/cutStrAtAndAddDots";
import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";

//MUI
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import RefreshBtn from "Components/UI/Tables/RefreshBtn";
import { useAccountCharts } from "Context/AccountCharts";

const createRows = (articles, accountCharts) => {
  return articles.map((a) => {
    const debitAccount = accountCharts.find(
      (ac) => Number(ac.Id) === Number(a.DebitAccountChartId)
    );
    const creditAccount = accountCharts.find(
      (ac) => Number(ac.Id) === Number(a.CreditAccountChartId)
    );
    return [
      a.Id,
      a.Title,
      a.Name,
      {
        name: debitAccount
          ? debitAccount.AccountNumber + " - " + debitAccount.Name
          : "",
        id: debitAccount ? debitAccount.Id : 0,
      },
      {
        name: creditAccount
          ? creditAccount.AccountNumber + " - " + creditAccount.Name
          : "",
        id: creditAccount ? creditAccount.Id : 0,
      },
      a.VAT,
      a.Payrule,
      a.Paytype,
      getParseStatusLabelById(a.ParseStatus),
      cutStrAtAndAddDots(a.ParseMessage, 45),
      getSystemStatusLabelById(a.SystemStatus),
      a.CreateTime,
    ];
  });
};

export default function EndcustomerArticlesTableContainer({ articles }) {
  const [rows, setRows] = useState([]);
  const { accountCharts } = useAccountCharts();

  useEffect(() => {
    const rows = createRows(articles, accountCharts);
    setRows(rows);
  }, [accountCharts, articles]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Titel",
      options: {
        filter: false,
      },
    },
    {
      name: "Namn",
      options: {
        filter: false,
      },
    },
    {
      name: "Debet konto",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <Link to={`/accountcharts/${value.id}`}>{value.name}</Link>;
        },
      },
    },
    {
      name: "Kredit konto",
      options: {
        filter: false,
        customBodyRender: (value) => {
          return <Link to={`/accountcharts/${value.id}`}>{value.name}</Link>;
        },
      },
    },
    {
      name: "Moms (VAT)",
      options: {
        filter: false,
      },
    },
    {
      name: "Betalregel",
      options: {
        filter: false,
      },
    },
    {
      name: "Betaltyp",
      options: {
        filter: false,
      },
    },
    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    customToolbar: () => {
      return (
        <>
          <RefreshBtn />
        </>
      );
    },
    filterType: "dropdown",
    responsive: "standard",
    downloadOptions: {
      separator: ";",
      filename: "client_accounts.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable title={""} options={options} data={rows} columns={columns} />
  );
}
